"use client";
import type { PropsWithChildren } from "react";
import { BrowserDataScopeProvider } from "./browser-data-scope-provider";
import {
  useBrowserDataOwner,
  type BrowserDataOwnerOptions,
} from "./use-browser-data-owner";

export function BrowserDataProvider({
  children,
  ...options
}: PropsWithChildren<BrowserDataOwnerOptions>) {
  const scope = useBrowserDataOwner(options);
  return (
    <BrowserDataScopeProvider scope={scope}>
      {children}
    </BrowserDataScopeProvider>
  );
}
